import React, { useState } from 'react';
import './AccessibilityWidget.scss';

const AccessibilityWidget: React.FC = () => {
  const [open, setOpen] = useState(false);

  const toggleToolbar = () => {
    setOpen(!open);
  };

  const changeFontSize = (action: 'increase' | 'decrease') => {
    const body = document.body;
    const style = window.getComputedStyle(body).fontSize;
    const size = parseFloat(style);
    body.style.fontSize = `${action === 'increase' ? size + 2 : size - 2}px`;
  };

  const invertColors = () => {
    const body = document.body;
    body.style.filter = body.style.filter === 'invert(1)' ? 'invert(0)' : 'invert(1)';
  };

  const toggleDyslexiaFont = () => {
    const body = document.body;
    body.style.fontFamily =
      body.style.fontFamily === 'OpenDyslexic' ? 'Open Sans, sans-serif' : 'OpenDyslexic';
  };

  const toggleImages = () => {
    document.querySelectorAll<HTMLImageElement>('img').forEach((img) => {
      img.style.display = img.style.display === 'none' ? 'inline' : 'none';
    });
  };

  const toggleTheme = () => {
    document.body.classList.toggle('dark-theme');
  };

  return (
    <div className="accessibility-widget-wrapper">
      <div className="accessibility-widget-container">
        {open && (
          <div id="accessibility-toolbar" className="accessibility-toolbar">
            <div className="toolbar-header">
              <strong>Accessibility</strong>
              <button
                className="close-btn"
                onClick={toggleToolbar}
                aria-label="Close accessibility toolbar"
              >
                &times;
              </button>
            </div>
            <div className="toolbar-grid">
              <button onClick={() => changeFontSize('increase')}>🔠 Bigger Text</button>
              <button onClick={() => changeFontSize('decrease')}>🔡 Smaller Text</button>
              <button onClick={invertColors}>💧 Invert Colors</button>
              <button onClick={toggleDyslexiaFont}>🧠 Dyslexia Font</button>
              <button onClick={toggleImages}>🚫 Hide Images</button>
              <button onClick={toggleTheme}>🌙 Dark Mode</button>
            </div>
          </div>
        )}

        <button
          className="accessibility-toggle-btn"
          onClick={toggleToolbar}
          aria-label="Toggle accessibility toolbar"
        >
          ♿
        </button>
      </div>
    </div>
  );
};

export default AccessibilityWidget; 